<div class="banner">
  <!-- Background -->
  <div class="banner__media"></div>

  <!-- Inner layout -->
  <div class="banner__inner">

    <!-- Left: hero content -->
    <div class="banner__content">
      <div class="banner__tag">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
        IISc Healthcare Innovation Challenge
      </div>

      <h1 class="banner__title">
        AB PMJAY<br />
        Auto-Adjudication<br />
        Hackathon
      </h1>

      <p class="banner__description">
        Join the national initiative to build innovative AI and machine learning
        solutions for auto-adjudication in healthcare claims. Help shape the future
        of India's digital health infrastructure.
      </p>

      <div class="banner__pills">
        <span class="banner__pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
          8th &amp; 9th May, 2026
        </span>
        <span class="banner__pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          IISc Bengaluru
        </span>
      </div>
    </div>

    <!-- Right: registration card -->
    <div class="banner__card">
      <p class="banner__card-heading">HACKATHON REGISTRATION</p>

      <div class="banner__card-info">
        <div class="banner__card-row">
          <span class="banner__card-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
          </span>
          <div class="banner__card-text">
            <span class="banner__card-label">Event date</span>
            <span class="banner__card-value">8th &amp; 9th May, 2026</span>
          </div>
        </div>

        <div class="banner__card-row">
          <span class="banner__card-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
          </span>
          <div class="banner__card-text">
            <span class="banner__card-label">Venue</span>
            <span class="banner__card-value">IISc Bengaluru</span>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
